<ng-container *transloco="let t">
	<div class="flex flex-col" *ngIf="!$updatingCartItem(); appLoadingAnimation">
		<vis-ods-icon-button-component
			name="backArrow"
			class="pb-m block"
			(click)="navigateBack()"
		></vis-ods-icon-button-component>
		<div class="flex flex-col">
			<div class="flex flex-row bg-light-01 py-m mb-l px-2xs">
				<vis-ods-icon-component
					name="search"
					class="flex w-[15px] h-[15px] mt-[13px]"
				></vis-ods-icon-component>
				<input
					type="text"
					autocomplete="off"
					class="text-body text-body-m bg-transparent border-0 w-full focus:ring-transparent border-b border-inactive focus:border-inactive"
					placeholder="{{ t('generalComponents.contactPersonSelector.texts.placeholder') }}"
					(input)="searchTermChanged($any($event.target).value)"
				/>
			</div>
			<div class="flex flex-col">
				<ng-container *ngIf="!$loading(); appLoadingAnimation">
					@for (contactPerson of $contactPersons(); track contactPerson.contactNumber) {
						<label
							class="flex items-start py-m cursor-pointer border-inactive border-b"
							(click)="onContactPersonChange(contactPerson)"
						>
							<input
								type="radio"
								class="mt-2xs cursor-pointer"
								[checked]="contactPerson.contactNumber === $selectedContactPerson()?.contactNumber"
							/>
							<beyond-online-headline
								class="ml-m flex flex-col"
								size="xs"
								[headline]="contactPerson.firstName + ' ' + contactPerson.lastName"
							></beyond-online-headline>
						</label>
					}
					<div
						class="flex flex-col text-body-s text-body py-m cursor-pointer border-inactive border-b"
					>
						{{ t('generalComponents.contactPersonSelector.texts.footer') }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</ng-container>
